import { maxHeaderSize } from 'http';
import React, { ReactNode } from 'react';
import { IChildrenProp, IDiv } from 'types/components/components.interface';
import './ContainerHeader.scss';


interface IContainerHeaderProps extends IChildrenProp, Omit<IDiv, 'title'> {
  title?: ReactNode;
}

const ContainerHeader = ({
  title,
  children,
  className = '',
  ...props
}: IContainerHeaderProps) => {
  return (
    <div {...props} className={`container-header ${className}`}>
      <div className='title'>{title}</div>
      <div className='children'>{children}</div>
    </div>
  );
};

export default ContainerHeader;
